import React from "react";
import styled from "styled-components";
import useProductName from "brand-customization/useProductName";
import { Button, Col, Row } from "components/bootstrap";
import ForwarderDiagram from "forwarder/wizard/ForwarderDiagram";
import { StyledTitle } from "./StyledWizardComponents";
const StyledContent = styled.p`
  font-size: 1.2em;
  margin-bottom: 20px;
`;
const StyledDiagram = styled(ForwarderDiagram)`
  margin-top: 35px;
  max-width: 600px;
  width: 100%;
`;
const WelcomeStep = ({ onStepComplete }) => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 5, lg: 6 }, /* @__PURE__ */ React.createElement(StyledTitle, null, "Send data to ", productName), /* @__PURE__ */ React.createElement(StyledContent, null, "Use ", productName, " Forwarder to get your data into ", productName, ". The Forwarder runs in your infrastructure and can run Inputs that receive logs from your applications and systems. ", productName, " allows you to set up a connection to one or more Forwarders that can send messages."), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onStepComplete }, "Start configuration")), /* @__PURE__ */ React.createElement(Col, { md: 6, mdOffset: 1, lg: 4, lgOffset: 1 }, /* @__PURE__ */ React.createElement(StyledDiagram, null)));
};
export default WelcomeStep;
